/**
 * 403 Forbidden Page
 *
 * Displayed when user tries to access a page without proper permissions
 */
import { Button, Result } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeOutlined, LockOutlined } from '@ant-design/icons';
import { logger } from '@/shared/utils/logger';

export const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Log forbidden access attempts
  logger.warn('403 Forbidden Access', { path: location.pathname });

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '24px',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you don't have permission to access this page. Please contact your administrator if you believe this is an error."
        icon={<LockOutlined style={{ fontSize: '72px', color: '#faad14' }} />}
        extra={[
          <Button
            type="primary"
            key="home"
            icon={<HomeOutlined />}
            onClick={handleGoHome}
          >
            Go Home
          </Button>,
          <Button key="back" onClick={handleGoBack}>
            Go Back
          </Button>,
        ]}
      />
    </div>
  );
};

export default ForbiddenPage;
